import store from "../../../store";
import counterparty_items from './counterparty_items.vue';

window.counterparty_items =  new Vue({
    store,
    el: '#counterparty_items',
    name : "counterparty_items",
    created () {

    },
    components : {
        counterparty_items
    }
})
